import ExitPopup from "components/QuickPurchasePage/ExitPopup"
import { useQuickPurchaseContext } from "components/QuickPurchasePage/QuickPurchaseContext"
import StickyBottomSummary from "components/StickyBottomSummary/StickyBottomSummary"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { FC, useRef } from "react"
import { useInView } from "react-intersection-observer"
import styled from "styled-components"

const Header = dynamic(() => import("./Header"), {
  loading: () => <p>...</p>,
})

const Footer = dynamic(() => import("./Footer"), {
  loading: () => <p>...</p>,
})

const StyledMain = styled.main`
  flex-grow: 1;

  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: column;
  }

  :focus {
    outline: 0;
  }
`

const StyledFooterContainer = styled.div<{ $page?: string }>`
  ${(p) => p?.$page === "/payment" && "margin-top: 100px;"}
  ${(p) => p.theme.breakpoints.down("sm")} {
    ${(p) => p?.$page === "/create-ai" && "margin-bottom: 68px;"}
  }
`

const Layout: FC<any> = ({ children }) => {
  const { pathname } = useRouter()
  const { showExitModal, showStickyBottom } = useQuickPurchaseContext()

  const [refFooter, inViewFooter] = useInView({ threshold: 0.4 })
  const mainRef = useRef<HTMLDivElement>(null)
  return (
    <>
      <ExitPopup showExitModal={showExitModal} />
      <Header />

      <StyledMain id="mainContent" tabIndex={-1} ref={mainRef}>
        {children}
      </StyledMain>

      <StyledFooterContainer ref={refFooter} $page={pathname}>
        <Footer />
      </StyledFooterContainer>
      {showStickyBottom && <StickyBottomSummary />}
    </>
  )
}

export default Layout
